module.exports = __webpack_public_path__ + "img/refund-line.c58204fd.svg";